// import { Controller } from "@hotwired/stimulus"
// import * as bootstrap from "bootstrap"
//
// export default class extends Controller {
//   static targets = ["modal"]
//
//   connect() {
//     // Inizializza la modale Bootstrap
//     this.modalInstance = new bootstrap.Modal(this.modalTarget)
//   }
//
//   open() {
//     this.modalInstance.show()
//   }
//
//   close() {
//     this.modalInstance.hide()
//   }
// }

// app/javascript/controllers/modal_controller.js
import { Controller } from "@hotwired/stimulus"
import * as bootstrap from "bootstrap"

export default class extends Controller {
  connect() {
    this.modal = bootstrap.Modal.getOrCreateInstance(this.element)
    this.modal.show()
    
    // quando Bootstrap chiude correttamente
    this.element.addEventListener("hidden.bs.modal", () => {
      this.cleanup()
    })
  }
  
  disconnect() {
    if (this.modal) {
      this.modal.hide()
      this.modal.dispose()
    }

    document.body.classList.remove("modal-open")
    document.querySelectorAll(".modal-backdrop").forEach(b => b.remove())
  }
  
  cleanup() {
    // 🔑 QUESTO È IL PEZZO CHE TI MANCAVA
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")

    document.querySelectorAll(".modal-backdrop").forEach(b => b.remove())

    if (this.modal) {
      this.modal.dispose()
      this.modal = null
    }
  }
}